import { Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Shared "Invoices / Scheduled" tab navigation. Used at the top of both the
 * invoices list page and the scheduled-invoices list page so the two views
 * feel like sibling tabs of one screen.
 *
 *   <InvoicesTabs current="invoices" />
 *   <InvoicesTabs current="scheduled" />
 */
export default function InvoicesTabs({ current }) {
    const navigate = useNavigate();
    return (
        <Tabs
            value={current}
            onChange={(_, v) => {
                if (v === current) return;
                if (v === 'invoices') navigate('/invoices');
                if (v === 'scheduled') navigate('/invoice-schedules');
            }}
            sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
        >
            <Tab value="invoices" label="Invoices" />
            <Tab value="scheduled" label="Scheduled" />
        </Tabs>
    );
}
